import { PhoneCall } from "lucide-react";
import { Step, Q_INPUT, Q_LABEL } from "./Step";

export function RouteStep({ pricing, originId, setOriginId, destId, setDestId, origin }) {
  const countries = [...new Set(pricing.origins.map((o) => o.country))];
  return (
    <Step n="1" title="Where are you shipping from and to?" hint="Prices vary by pickup area and destination." testId="quote-step-route">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={Q_LABEL}>Shipping from</label>
          <select value={originId} onChange={(e) => setOriginId(e.target.value)} className={Q_INPUT} data-testid="quote-origin-select">
            <option value="">— Select your area —</option>
            {countries.map((c) => (
              <optgroup key={c} label={c}>
                {pricing.origins.filter((o) => o.country === c).map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
              </optgroup>
            ))}
          </select>
        </div>
        <div>
          <label className={Q_LABEL}>Shipping to</label>
          <select value={destId} onChange={(e) => setDestId(e.target.value)} className={Q_INPUT} data-testid="quote-destination-select">
            <option value="">— Select destination —</option>
            {pricing.destinations.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
      </div>
      {origin && !origin.auto_confirm && (
        <div className="mt-4 flex gap-3 p-4 bg-[#FFD700]/15 border border-[#FFD700] rounded-sm text-sm text-[#1E2A78]" data-testid="quote-confirm-notice">
          <PhoneCall className="h-5 w-5 shrink-0 mt-0.5" />
          <span>Bookings from <b>{origin.name}</b> are confirmed by our customer service team by phone before they are finalized.</span>
        </div>
      )}
      {origin && <p className="mt-3 text-xs text-slate-500">Prices for this area are shown in <b>{origin.currency}</b>.</p>}
    </Step>
  );
}
